export default __webpack_public_path__ + "static/media/b2.4be48363.png";